import { Injectable } from '@angular/core';
import { BaseErrorMappingService } from '../base-error-mapping.service';
import type { ErrorRule } from '../../../models/error-mapping.model';
import { BANK_ACCOUNT_ERROR_CODES } from '@features/bank-accounts/models/bank-account.constants';

@Injectable({
  providedIn: 'root'
})
export class BankAccountErrorMappingService extends BaseErrorMappingService {
  protected rules: ErrorRule[] = [
    {
      pattern: /\/CustomerBankAccount\/|\/bank-accounts\//,
      messages: {
        400: 'errors.bankAccountValidationFailed',
        403: 'errors.bankAccountForbidden',
        404: 'errors.bankAccountNotFound',
        500: 'errors.bankAccountOperationFailed',
        success: {
          [BANK_ACCOUNT_ERROR_CODES.NOT_FOUND]: 'errors.bankAccountNotFound',
          [BANK_ACCOUNT_ERROR_CODES.INVALID_IBAN]: 'bankAccounts.errors.invalidIban',
          [BANK_ACCOUNT_ERROR_CODES.INVALID_BIC]: 'bankAccounts.errors.invalidBic',
          [BANK_ACCOUNT_ERROR_CODES.INVALID_ROUTING]: 'bankAccounts.errors.invalidRoutingNumber',
          [BANK_ACCOUNT_ERROR_CODES.DUPLICATE]: 'errors.bankAccountDuplicate',
          [BANK_ACCOUNT_ERROR_CODES.FORBIDDEN]: 'errors.bankAccountForbidden',
          [BANK_ACCOUNT_ERROR_CODES.VALIDATION_ERROR]: 'errors.bankAccountValidationFailed',
          default: 'errors.bankAccountOperationFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    }
  ];
}
